var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8586",
    "data-name": "Rectangle 8586",
    width: 24,
    height: 24,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9537",
    "data-name": "Group 9537",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14581",
    "data-name": "Path 14581",
    d: "M1188.72,283h-20.45a1.748,1.748,0,0,0-1.77,1.73v20.536a1.752,1.752,0,0,0,1.77,1.734h20.45a1.76,1.76,0,0,0,1.78-1.73V284.73A1.757,1.757,0,0,0,1188.72,283Zm-15.1,20.452h-3.56V291.995h3.56Zm-1.78-13.018a2.063,2.063,0,1,1,2.06-2.062A2.068,2.068,0,0,1,1171.84,290.434Zm15.11,13.018h-3.56v-5.569c0-1.327-.02-3.038-1.85-3.038-1.85,0-2.13,1.449-2.13,2.944v5.663h-3.55V291.995h3.41v1.566h.05a3.724,3.724,0,0,1,3.36-1.852c3.61,0,4.27,2.372,4.27,5.457Z",
    transform: "translate(-1166.5 -283)",
    fill: "#858689"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.e0feb29b99f770e5329ecdb2c015192b.svg";
export { ForwardRef as ReactComponent };